export default () => {
  function isPageEditor() {
    return !!(typeof Sitecore !== 'undefined' && Sitecore && Sitecore.PageModes && Sitecore.PageModes.PageEditor);
  }

  const t = {
    XXLARGE: 1,
    XLARGE: 2,
    LARGE: 3,
    MEDIUM: 4,
    SMALL: 5
  };

  const calculateTileSize = (numberOfTiles) => (numberOfTiles >= t.SMALL ? t.SMALL : numberOfTiles);

  const tileConfig = (numberOfTiles, comparison, extra) => {
    const tileSize = calculateTileSize(numberOfTiles);
    return {
      items: tileSize < comparison ? numberOfTiles : comparison,
      nav: tileSize > comparison,
      stagePadding: tileSize > comparison ? 50 : 0,
      mouseDrag: tileSize > comparison,
      touchDrag: tileSize > comparison,
      ...extra
    };
  };

  $('.owl-carousel.tiles').each((index, tiles) => {
    const $tiles = $(tiles);
    const numberOfTiles = $('.tile', $tiles).length;
    $tiles.addClass(`tiles__${numberOfTiles}-col`);
    $tiles.owlCarousel({
      items: 1,
      loop: false,
      margin: 20,
      nav: true,
      navText: ['', ''],
      stagePadding: 0,
      autoWidth: isPageEditor(),
      onResized: () => {
        $tiles.trigger('refresh.owl.carousel');
      },
      responsiveRefreshRate: 10,
      responsive: {
        0: tileConfig(numberOfTiles, t.XXLARGE, { margin: 0 }),
        375: tileConfig(numberOfTiles, t.XXLARGE, { margin: 0 }),
        480: tileConfig(numberOfTiles, t.XLARGE),
        840: tileConfig(numberOfTiles, t.LARGE),
        1025: tileConfig(numberOfTiles, t.MEDIUM),
        1280: tileConfig(numberOfTiles, t.SMALL)
      }
    });
  });
};
